import * as React from "react";
import "./global.css";
import sendUmamiTrackEvent from "./src/helpers/sendUmamiTrackEvent";

export const onClientEntry = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (window.__youtubeLinkTrackingEnabled) return;

  const handleLinkClick = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const anchor = target.closest("a");
    const href = anchor?.href;

    if (!href) return;

    const hrefLower = href.toLowerCase();

    if (hrefLower.includes("https://info.wirepas.com/hubfs/pdf%20material/")) {
      sendUmamiTrackEvent({ eventName: "download_page_link_click" });
    }
  };

  document.addEventListener("click", handleLinkClick, true);
  window.__youtubeLinkTrackingEnabled = true;
};
